import type { DynamicValidation} from '@/types/utils/passwordValidations.type.ts';

export interface PasswordValidationRules {
  minLength: number
  requireUppercase: boolean
  requireNumber: boolean
  requireSpecial: boolean
}

export const PasswordRules: PasswordValidationRules = {
  minLength: 10,
  requireUppercase: true,
  requireNumber: true,
  requireSpecial: true
}

export const PasswordPatterns = {
  uppercase: /[A-Z]/,
  number: /[0-9]/,
  special: /[!@#\$%\^&\*\(\)_\+\-=\[\]\{\};':"\\|,.<>\/\?]/
}

export function validatePasswordDynamic(password: string): DynamicValidation {
  if (!password) {
    return {
      length: false,
      upper: false,
      number: false,
      special: false
    }
  }

  return {
    length: password.length >= PasswordRules.minLength,
    upper: PasswordPatterns.uppercase.test(password),
    number: PasswordPatterns.number.test(password),
    special: PasswordPatterns.special.test(password)
  }
}

